// Chakra imports
import {
  Table,
  Tbody,
  Tr,
  Td,
  TableContainer,
  Text,
  useColorModeValue,
  Box,
  Icon,
  Thead,
  Th,
  Tooltip,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import './modal.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const TerminalObjectResultJson = ({ title, value, provider, env, type }) => {
  //Brt & Amonat payment
  const PAYMENT_PARAMS = ['channel'];
  let CHANNEL = ['Amonat', 'amonatbonk_tj', 'brt_tj', 'Brt'];

  //Brt & Amonat payout
  const PAYOUT_PARAMS = [
    'channel',
    'sp_name',
    'client_id',
    'terminal_id',
    'msg_receiver',
    'service_code',
    'source_product_id',
    'source_product_type',
  ];
  let SP_NAME = ['BPA_BRT', 'BPA_AMONAT'];
  let CLIENT_ID = ['brt-bpa-api', 'amonat-bpa-api'];
  let TERMINAL_ID = ['60000BRT01'];
  let MSG_RECEIVER = ['PHUB'];
  let SERVICE_CODE = [10701, 7238, 12330];
  let SOURCE_PRODUCT_ID = [4];
  let SOURCE_PRODUCT_TYPE = 'ACCOUNT';

  //SBP payment
  const SBP_PAYMENT_PARAMS = [
    'channel',
    'merchant_id',
    'ext_entity_id',
    'account_alias',
    'client_id',
  ];
  let MERCHANT_ID = ['MA0002242049'];
  let EXT_ENTITY_ID = ['XTGVMTVCC'];
  let ACCOUNT_ALIAS = [
    '4152c220abc0fea637c2c5bc3a06f49461df7f99a25fe2f4133943472cb08b59',
  ];

  const textColor = useColorModeValue('gray.700', 'white');
  const [selected, setSelected] = useState(true);
  const [inParams, setIn] = useState([]);
  const [outParams, setOut] = useState([]);
  const [light, setLight] = useState(null);
  const [red1, setRed1] = useState(false);
  const [red2, setRed2] = useState(false);
  const [red3, setRed3] = useState(false);
  const [red4, setRed4] = useState(false);
  const [red5, setRed5] = useState(false);
  const [red6, setRed6] = useState(false);
  const [red7, setRed7] = useState(false);
  const [red8, setRed8] = useState(false);
  const [red9, setRed9] = useState(false);
  const [red10, setRed10] = useState(false);
  const [red11, setRed11] = useState(false);
  const [alertColor, setAlertColor] = useState('#7fdfd6');

  const toggle = () => {
    setSelected(!selected);
  };

  const colorEditorPayout = () => {
    if (
      !CHANNEL.includes(value.channel) ||
      !SP_NAME.includes(value.sp_name) ||
      !CLIENT_ID.includes(value.client_id) ||
      !TERMINAL_ID.includes(value.terminal_id) ||
      !MSG_RECEIVER.includes(value.msg_receiver) ||
      !SERVICE_CODE.includes(value.service_code) ||
      !SOURCE_PRODUCT_ID.includes(value.source_product_id) ||
      !SOURCE_PRODUCT_TYPE.includes(value.source_product_type)
    ) {
      if (!CHANNEL.includes(value.channel)) {
        setAlertColor('#e70e27');
        setRed1(true);
      }
      if (!SP_NAME.includes(value.sp_name)) {
        setAlertColor('#e70e27');
        setRed2(true);
      }
      if (!CLIENT_ID.includes(value.client_id)) {
        setAlertColor('#e70e27');
        setRed3(true);
      }
      if (!TERMINAL_ID.includes(value.terminal_id)) {
        setAlertColor('#e70e27');
        setRed4(true);
      }
      if (!MSG_RECEIVER.includes(value.msg_receiver)) {
        setAlertColor('#e70e27');
        setRed5(true);
      }
      if (!SERVICE_CODE.includes(value.service_code)) {
        setAlertColor('#e70e27');
        setRed6(true);
      }
      if (!SOURCE_PRODUCT_ID.includes(value.source_product_id)) {
        setAlertColor('#e70e27');
        setRed7(true);
      }
      if (!SOURCE_PRODUCT_TYPE.includes(value.source_product_type)) {
        setAlertColor('#e70e27');
        setRed8(true);
      }
    } else {
      setAlertColor('#7fdfd6');
      setRed1(false);
      setRed2(false);
      setRed3(false);
      setRed4(false);
      setRed5(false);
      setRed6(false);
      setRed7(false);
      setRed8(false);
    }
  };

  const colorEditorPayment = () => {
    if (
      !CHANNEL.includes(value.channel) ||
      !CLIENT_ID.includes(value.client_id) ||
      !MERCHANT_ID.includes(value.merchant_id) ||
      !EXT_ENTITY_ID.includes(value.ext_entity_id) ||
      !ACCOUNT_ALIAS.includes(value.account_alias)
    ) {
      if (!CHANNEL.includes(value.channel)) {
        setAlertColor('#e70e27');
        setRed1(true);
      }
      if (!CLIENT_ID.includes(value.client_id)) {
        setAlertColor('#e70e27');
        setRed3(true);
      }
      if (!MERCHANT_ID.includes(value.merchant_id)) {
        setAlertColor('#e70e27');
        setRed9(true);
      }
      if (!EXT_ENTITY_ID.includes(value.ext_entity_id)) {
        setAlertColor('#e70e27');
        setRed10(true);
      }
      if (!ACCOUNT_ALIAS.includes(value.account_alias)) {
        setAlertColor('#e70e27');
        setRed11(true);
      }
    } else {
      setAlertColor('#7fdfd6');
      setRed1(false);
      setRed3(false);
      setRed9(false);
      setRed10(false);
      setRed11(false);
    }
  };

  useEffect(() => {
    if (provider === 'mtsbank' && env === 'prod') {
      //Проверка provider_params терминала СБП
      if (value.payment_system_type) {
        value.payment_system_type.forEach(id => {
          if (id === 'sbp') {
            if (type === 'payment') {
              //payment
              const objectArray1 = paramsInArray(value, SBP_PAYMENT_PARAMS);
              setIn(Object.entries(objectArray1));
              const objectArray2 = paramsNotInArray(value, SBP_PAYMENT_PARAMS);
              setOut(Object.entries(objectArray2));
              setLight(SBP_PAYMENT_PARAMS);
              colorEditorPayment();
            } else {
              //payout
              const objectArray1 = paramsInArray(value, PAYOUT_PARAMS);
              setIn(Object.entries(objectArray1));
              const objectArray2 = paramsNotInArray(value, PAYOUT_PARAMS);
              setOut(Object.entries(objectArray2));
              setLight(PAYOUT_PARAMS);
              colorEditorPayout();
            }
          }
        });
      } else {
        //Проверка provider_params терминала Brt и Амонат
        if (type === 'payment') {
          //payment
          const objectArray1 = paramsInArray(value, PAYMENT_PARAMS);
          setIn(Object.entries(objectArray1));
          const objectArray2 = paramsNotInArray(value, PAYMENT_PARAMS);
          setOut(Object.entries(objectArray2));
          setLight(PAYMENT_PARAMS);
          if (!CHANNEL.includes(value.channel)) {
            if (!CHANNEL.includes(value.channel)) {
              setAlertColor('#e70e27');
              setRed1(true);
            }
          } else {
            setAlertColor('#7fdfd6');
            setRed1(false);
          }
        } else {
          //payout
          const objectArray1 = paramsInArray(value, PAYOUT_PARAMS);
          setIn(Object.entries(objectArray1));
          const objectArray2 = paramsNotInArray(value, PAYOUT_PARAMS);
          setOut(Object.entries(objectArray2));
          setLight(PAYOUT_PARAMS);
          colorEditorPayout();
        }
      }
    } else {
      const objectArray1 = paramsInArray(value, []);
      setIn(Object.entries(objectArray1));
      const objectArray2 = paramsNotInArray(value, []);
      setOut(Object.entries(objectArray2));
    }
  }, [value]);

  return (
    <>
      <Box>
        <TableContainer>
          <Table bg={alertColor} position="relative">
            <Thead>
              <Tr>
                <Th width={'100%'}>
                  <Text
                    fontSize="md"
                    color={textColor}
                    cursor="pointer"
                    onClick={toggle}
                  >
                    {light ? (
                      <Tooltip label={JSON.stringify(light, null, 2)}>
                        {title}
                      </Tooltip>
                    ) : (
                      title
                    )}
                  </Text>
                </Th>
                <Th>
                  <Icon
                    as={selected ? FaEye : FaEyeSlash}
                    color="gray.400"
                    cursor="pointer"
                    onClick={toggle}
                    style={{
                      width: '18px',
                      height: '18px',
                    }}
                  />
                </Th>
              </Tr>
            </Thead>
          </Table>
        </TableContainer>
      </Box>
      {selected && (
        <Box>
          <TableContainer>
            <Table variant="striped">
              <Tbody>
                {inParams.map(([key, value]) => {
                  return (
                    <Tr key={key}>
                      <Td
                        width={'50%'}
                        fontWeight="bold"
                        color={
                          key === 'channel'
                            ? red1
                              ? 'red'
                              : 'green'
                            : '' || key === 'sp_name'
                            ? red2
                              ? 'red'
                              : 'green'
                            : '' || key === 'client_id'
                            ? red3
                              ? 'red'
                              : 'green'
                            : '' || key === 'terminal_id'
                            ? red4
                              ? 'red'
                              : 'green'
                            : '' || key === 'msg_receiver'
                            ? red5
                              ? 'red'
                              : 'green'
                            : '' || key === 'service_code'
                            ? red6
                              ? 'red'
                              : 'green'
                            : '' || key === 'source_product_id'
                            ? red7
                              ? 'red'
                              : 'green'
                            : '' || key === 'source_product_type'
                            ? red8
                              ? 'red'
                              : 'green'
                            : '' || key === 'merchant_id'
                            ? red9
                              ? 'red'
                              : 'green'
                            : '' || key === 'ext_entity_id'
                            ? red10
                              ? 'red'
                              : 'green'
                            : '' || key === 'account_alias'
                            ? red11
                              ? 'red'
                              : 'green'
                            : ''
                        }
                      >
                        {key === 'channel' && (
                          <Tooltip label={JSON.stringify(CHANNEL, null, 2)}>
                            {key}
                          </Tooltip>
                        )}
                        {key === 'sp_name' && (
                          <Tooltip label={JSON.stringify(SP_NAME, null, 2)}>
                            {key}
                          </Tooltip>
                        )}
                        {key === 'client_id' && (
                          <Tooltip label={JSON.stringify(CLIENT_ID, null, 2)}>
                            {key}
                          </Tooltip>
                        )}
                        {key === 'terminal_id' && (
                          <Tooltip label={JSON.stringify(TERMINAL_ID, null, 2)}>
                            {key}
                          </Tooltip>
                        )}
                        {key === 'msg_receiver' && (
                          <Tooltip
                            label={JSON.stringify(MSG_RECEIVER, null, 2)}
                          >
                            {key}
                          </Tooltip>
                        )}
                        {key === 'service_code' && (
                          <Tooltip
                            label={JSON.stringify(SERVICE_CODE, null, 2)}
                          >
                            {key}
                          </Tooltip>
                        )}
                        {key === 'source_product_id' && (
                          <Tooltip
                            label={JSON.stringify(SOURCE_PRODUCT_ID, null, 2)}
                          >
                            {key}
                          </Tooltip>
                        )}
                        {key === 'source_product_type' && (
                          <Tooltip
                            label={JSON.stringify(SOURCE_PRODUCT_TYPE, null, 2)}
                          >
                            {key}
                          </Tooltip>
                        )}
                        {key === 'merchant_id' && (
                          <Tooltip label={JSON.stringify(MERCHANT_ID, null, 2)}>
                            {key}
                          </Tooltip>
                        )}
                        {key === 'ext_entity_id' && (
                          <Tooltip
                            label={JSON.stringify(EXT_ENTITY_ID, null, 2)}
                          >
                            {key}
                          </Tooltip>
                        )}
                        {key === 'account_alias' && (
                          <Tooltip
                            label={JSON.stringify(ACCOUNT_ALIAS, null, 2)}
                          >
                            {key}
                          </Tooltip>
                        )}
                      </Td>
                      <Td width={'50%'}>{JSON.stringify(value, null, 2)}</Td>
                    </Tr>
                  );
                })}
                {outParams.map(([key, value]) => {
                  return (
                    <Tr key={key}>
                      <Td width={'50%'} fontWeight="bold">
                        {key}
                      </Td>
                      <Td width={'50%'}>{JSON.stringify(value, null, 2)}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
};

export default TerminalObjectResultJson;

function paramsInArray(value, params) {
  let obj_in = {};
  let keys = Object.keys(value);
  let data = Object.values(value);

  for (let i = 0; i < keys.length; ++i) {
    for (let j = 0; j < params.length; ++j) {
      if (params[j] === keys[i]) {
        obj_in[keys[i]] = data[i];
        break;
      }
    }
  }
  return obj_in;
}

function paramsNotInArray(value, params) {
  let obj_out = {};
  let keys = Object.keys(value);
  let data = Object.values(value);
  let flag = false;

  for (let i = 0; i < keys.length; ++i) {
    flag = false;
    for (let j = 0; j < params.length; ++j) {
      if (params[j] === keys[i]) {
        flag = true;
        break;
      }
    }
    if (!flag) {
      obj_out[keys[i]] = data[i];
    }
  }

  return obj_out;
}
